import React, { ComponentProps } from 'react';
import LazyLoad from 'react-lazyload';
import ProductImageCardInner from './ProductImageCardInner';
import config from '../../components/LazyLoadComponents/config';

interface ProductImageCardOwnProps {
  height: string;
  lazyLoad: boolean;
  width: string;
}

type ProductImageCardProps = ProductImageCardOwnProps & ComponentProps<typeof ProductImageCardInner>;

const ProductImageCard: React.FC<ProductImageCardProps> = props => {
  const { lazyLoad, width, height, placeholderWidth, placeholderHeight } = props;

  return !lazyLoad ? (
    <ProductImageCardInner {...props} />
  ) : (
    <LazyLoad height={placeholderHeight || height} width={placeholderWidth || width} {...config.productImageCard}>
      <ProductImageCardInner {...props} />
    </LazyLoad>
  );
};

export default ProductImageCard;
